import wrapper from 'wrapper';

function supportsStickyCheck() {
    // https: //codepen.io/xram/pen/hvDCK
    const el = document.createElement('a');
    const mStyle = el.style;
    mStyle.cssText = 'position:sticky;position:-webkit-sticky;position:-ms-sticky;';
    return mStyle.position.indexOf('sticky') !== -1;
}

function addScrollListener(graphicClass, containerClass) {
    let stuck = false;
    const graphicEl = wrapper.select(graphicClass);
    const containerEl = wrapper.select(containerClass);

    const top = 0;
    const adjustedTop = top + 10; // gives some buffer room
    const adjustedTopScrollDown = top - 100; // gives some buffer room when scrolling down

    const vh = window.innerHeight || document.documentElement.clientHeight;
    wrapper.onRawScroll((scrollPosition) => {
        const graphicBounds = graphicEl.getBoundingClientRect();
        const containerBounds = containerEl.getBoundingClientRect();
        // enter container top
        if (graphicBounds.top < adjustedTop && graphicBounds.top > adjustedTopScrollDown && !stuck) {
            stuck = true;
            graphicEl.classList.add('fix-position');
        }
        // exit container top
        else if (containerBounds.top > adjustedTop && stuck) {
            stuck = false;
            graphicEl.classList.remove('fix-position');
        }
    });
}

function unstick(graphic) {
    wrapper.select(graphic).classList.remove('fix-position');
    wrapper.select(graphic).classList.add('exit-container');
}

function stick(graphic) {
    wrapper.select(graphic).classList.add('fix-position');
    wrapper.select(graphic).classList.remove('exit-container');
}

export {
    supportsStickyCheck,
    addScrollListener,
    stick,
    unstick,
};
